import { SCRIM } from "@/components/ui/Scrim";
import { cn } from "@/lib/cn";
import { dialogVariants } from "@/lib/motion";

/** Backdrop of the blocking overlays (StatusOverlay, LoadingOverlay). */
export const OVERLAY_BACKDROP = cn("fixed inset-0 grid place-items-center p-6", SCRIM);

/** Layout of the blocking overlays' card, rendered on a `motion.create(Surface)` that paints the card surface. */
export const OVERLAY_CARD = "flex w-full max-w-sm flex-col items-center rounded-sheet px-6 py-10 text-center shadow-overlay";

/** Enter/exit of the overlay card: the shared dialog preset. */
export function overlayCardMotion(reduceMotion: boolean | null) {
  return {
    variants: dialogVariants(reduceMotion),
    initial: "hidden",
    animate: "visible",
    exit: "exit",
  };
}
